<template>
	<div>
		<CubePage type="myorder-view" title="出行详情">
			<div slot="content" class="content">
				<van-sticky :offset-top="44">
					<van-search placeholder="请输入联系人/联系电话/上车点" v-model="search" @search="onSearch" show-action>
						<div slot="action" @click="onSearch">
							<van-button type="primary">搜索</van-button>
						</div>
					</van-search>
				</van-sticky>
				<div class="tags tagsbtn">
					<van-button :class="use_status==''?'van-button-active':''" @click="onTagCalBtn('')" plain round size="mini">全部
					</van-button>
					<van-button :class="use_status=='10'?'van-button-active':''" @click="onTagCalBtn('10')" plain round
						size="mini">待核销</van-button>
					<van-button :class="use_status=='20'?'van-button-active':''" @click="onTagCalBtn('20')" plain round
						size="mini">已核销</van-button>
				</div>
				<div class="codemain" style="margin-top: 10px;">
					<van-empty v-if="isNoData" class="custom-image" description="暂无出行信息">
						<template #image>
							<img src="@/assets/img/empty.png" alt="">
						</template>
					</van-empty>
					<van-list v-else v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad()"
						:immediate-check="false">
						<div class="list-box">
							<div class="list-item" v-for="(item,index) in listData" :key="index">
								<div class="item-card">
									<div class="card-content">
										<div class="conten-desc ells">
											<p>
												联系人: <span style="padding-left: 5px;">{{item.contacts || '--'}} * {{item.total}}</span>
											</p>
											<p>
												联系电话:
												<span class="phpne" @click="goPhone(item.telephone)">
													{{item.telephone}}
													<van-icon name="phone-o" />
												</span>
												<!--                        <span style="padding-left: 5px;">{{item.telephone || '&#45;&#45;'}}</span>-->
											</p>
										</div>
										<div class="conten-desc">
											<p style="width: 110px">
												核销状态:<span style="padding-left: 5px;">{{item.use_status_text || '--'}}</span>
											</p>
											<p>
												通知时间:<span class="time" style="padding-left: 5px;">{{item.send_date || '--'}}</span>
											</p>
										</div>
										<div class="conten-desc">
											<p>
												上车点:<span style="padding-left: 5px;">{{item.point || '--'}}</span>
											</p>
											<p>
												备注:<span style="padding-left: 5px;">{{item.memo || '--'}}</span>
											</p>
										</div>
									</div>
								</div>
								<div style="display: flex;justify-content: flex-end;padding-right: 10px;padding-bottom: 10px; ">
									<van-button type="primary" @click="travelPoint(item)" size="mini" style="font-size: 12px">上车点
									</van-button>
									<van-button type="primary" @click="travelMemo(item)" size="mini" style="font-size: 12px">填写备注
									</van-button>
									<van-button type="primary" @click="departureNotify(item)" size="mini" style="font-size: 12px;">发车通知
									</van-button>
									<van-button v-if="item.use_status == '10'" type="primary" size="mini" style="font-size: 12px;"
										@click="gotostatus(item)">核销
									</van-button>
								</div>
							</div>
						</div>
					</van-list>
					<van-button block type="primary" class="gotocodestyle" @click="gotocode">扫码核销</van-button>
					<van-overlay :show="showMemo" @click="showMemo = false">
						<div class="wrapper" @click.stop>
							<div class="block">
								<h4>备注</h4>
								<van-field v-model="message" rows="2" :autosize="autosize" label="填写备注" type="textarea" maxlength="100"
									placeholder="请输入备注" show-word-limit />
								<div class="btn">
									<van-button type="primary" size="small" plain @click="showMemo = false">关闭</van-button>
									<van-button type="primary" size="small" @click="confirmbtn">确认</van-button>
								</div>
							</div>
						</div>
					</van-overlay>
					<van-popup v-model="travelshowbox" position="bottom">
						<van-picker v-if="traveldata.length>0" title="标题" show-toolbar :columns="traveldata" @confirm="onConfirm" @cancel="onCancel" />
						<van-empty v-else description="暂无数据" />
					</van-popup>
				</div>
			</div>
		</CubePage>
	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue';
	import * as util from '@/utils/network';
	import wx from 'weixin-js-sdk'
	import {
		Toast
	} from 'vant'
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				search: '',
				loading: false,
				finished: false,
				isNoData: false,
				listData: [],
				pageIndex: 1,
				pageTotal: 0,
				showMemo: false,
				message: '',
				autosize: {
					minHeight: 100
				},
				newlist: {},
				ismemo: false,
				use_status: '',
				orderno: '',
				travelshowbox: false, // 上车点show
				traveldata: [], //上车点数据
			}
		},
		created() {
			this.get_my_order()
		},
		methods: {
			onSearch() {
				this.clearContainer();
				this.get_my_order();
			},
			// 初始化数据
			clearContainer() {
				this.loading = false
				this.finished = false
				this.listData = []
				this.isNoData = false
				this.pageIndex = 1
				this.pageTotal = 0
			},
			// 上滑加载更多
			onLoad() {
				if (this.ismemo) return
				let that = this;
				// 异步更新数据
				that.pageIndex++;
				setTimeout(() => {
					that.get_my_order();
				}, 1000)
			},
			//拨打电话
			goPhone(e) {
				window.location.href = "tel://" + e;
			},
			get_my_order() {
				var url = "/addons/litestore/api.supplier/travelDetail"
				let that = this;
				//这里直接调用网络接口
				util.post(url, {
						page: that.pageIndex,
						id: this.$route.query.id,
						search: that.search,
						use_status: that.use_status
					},
					function(result) {
						that.ismemo = false;
						that.loading = false;
						//这里对状态 进行分类 
						that.pageTotal = result.total
						if (that.pageTotal < 1) {
							that.isNoData = true
							return;
						}
						if (result.rows == null || result.rows.length === 0) {
							// 加载结束
							that.finished = true;
							return;
						}
						// 将新数据与老数据进行合并
						that.listData = that.listData.concat(result.rows);

						//如果列表数据条数>=总条数，不再触发滚动加载
						if (that.listData.length >= that.pageTotal) {
							that.finished = true;
						}
					},
				);
			},
			// 上车点
			travelPoint(val) {
				this.travelshowbox = true;
				this.newlist = val;
				this.traveldata = val.start_point;
			},
			// 备注
			travelMemo(val) {
				this.showMemo = true;
				this.newlist = val;
			},
			// 提交备注
			confirmbtn() {
				let message = this.message;
				if (!message) {
					return Toast('备注信息不能为空')
				}
				let url = '/addons/litestore/api.supplier/travelMemo';
				let params = {
					other_id: this.newlist.other_id,
					memo: this.message
				}
				util.post(url, params, (res) => {
					if (res.code == 1) {
						Toast(res.msg);
						this.ismemo = true;
						this.showMemo = false;
						this.message = '';
						setTimeout(() => {
							this.onSearch();
						}, 1000)
					}
				})
			},
			// 发车通知
			departureNotify(val) {
				this.newlist = val;
				this.$dialog.confirm({
					title: '提示',
					message: '是否确认发送发车通知？'
				}).then(() => {
					this.departSmsFun()
				}).catch(() => {

				});
			},
			departSmsFun() {
				let url = '/addons/litestore/api.supplier/departSms';
				let params = {
					other_id: this.newlist.other_id,
				}
				util.post(url, params, (res) => {
					if (res.code == 1) {
						Toast('通知成功')
					}
				})
			},
			// 去核销
			gotostatus(val) {
				console.log(val)
				this.$router.push({
					path: 'wfnew',
					query: {
						code: val.code
					}
				})
			},
			// 切换核销昨天
			onTagCalBtn(val) {
				if (this.use_status == val) return
				this.use_status = val;
				this.onSearch();
			},
			// 扫码核销
			gotocode() {
				let that = this;
				console.log(wx)
				wx.scanQRCode({
					needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
					scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
					success(res) {
						var code = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
						console.log('扫描结果:', res);
						alert(code);
						that.orderno = code;
						that.submitCode();
						return false;
					},
					fail(res) {
						alert('微信js-sdk配置失败:::' + JSON.parse(res))
					}
				});
			},
			/**
			 * 出行
			 */
			// 确定
			onConfirm(value, index) {
				if(!value) return Toast('请选择上车点');
				let url = "/addons/litestore/api.supplier/travelPoint";
				let params = {
					other_id: this.newlist.other_id,
					point: value
				}
				util.post(url, params).then(res => {
					if (res.code == 1) {
						this.travelshowbox = false;
						this.listData.forEach(item => {
							if (item.id == this.newlist.id) {
								item.point = value
							}
						});
						Toast(res.msg)
					}
				})
			},
			// 取消
			onCancel() {
				//console.log('取消')
				this.travelshowbox = false
			},
			submitCode() {
				let that = this
				var url = "/addons/litestore/api.supplier/get_wirteoffcode";
				//这里直接调用网络接口
				util.post(url, {
						code: that.orderno
					},
					function(result) {
						that.$router.push({
							path: '/wfnew',
							query: {
								code: that.orderno
							}
						})
					},
				);
			}

		}
	}
</script>
<style lang="less">
	@import url("../../../assets/css/order.css");
	@import url("../../../assets/css/listboxless.less");
</style>
<style lang="less" type="text/css">
	.van-sticky {
		background: #fafafa !important;
	}
</style>
<style lang="less" scoped="scoped">
	.van-search {
		.van-search__action {
			line-height: 0;
		}

		.van-button {
			height: 34px;
		}
	}

	.cal-box {
		background-color: #ffffff;

		.cal-sc {
			padding: 10px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 14px;

			.title {
				color: #989898;
				padding-right: 10px;
			}

			.dj {
				width: 30px;
				text-align: center;
				//margin: 0 5px;
			}

			.cals {
				flex: 1;
				text-align: center;

				.ri {
					font-weight: 600;
				}
			}

			// }
		}

	}

	.list-box {
		.list-item {
			margin-bottom: 10px;
			background-color: #FFFFFF;

			.item-card {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 20px 15px;
				box-sizing: border-box;

				.card-img {
					width: 60px;
					height: 60px;
				}

				.v {
					width: 20px;
				}

				.card-content {
					flex: 1;
					margin: 0 15px;

					.red-text {
						color: #d40000;
					}

					.conten-title {
						display: flex;
						justify-content: space-between;

						.t {
							max-width: 140px;
							font-size: 16px;
							font-weight: 600;
						}

						.r {
							font-size: 14px;
						}
					}

					.conten-desc {
						padding-top: 8px;
						display: flex;
						justify-content: space-between;
						align-items: center;

						p {
							color: #a3a3a3;
							font-size: 14px;

							span {
								font-size: 13px;
								display: inline-block;
							}

							span.phpne,
							span.time {
								width: 126px;
							}

						}
					}
				}
			}

			.item-btns {
				height: 50px;
				display: flex;
				justify-content: space-around;
				align-items: center;

				.btn-item {

					.van-icon,
					.iconfont {
						vertical-align: middle;
						font-size: 20px;
					}

					.btn-text {
						font-size: 14px;
						padding: 0 5px;
					}
				}
			}
		}
	}

	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;

		.block {
			width: 80%;
			min-height: 200px;
			background-color: #fff;
			padding: 15px;
			border-radius: 4px;

			h4 {
				text-align: center;
				margin-bottom: 20px;
			}

			.btn {
				display: flex;
				align-items: center;
				justify-content: flex-end;
				margin-top: 15px;

				button {
					margin-left: 15px;
					padding: 0 30px;
					border-radius: 4px;
				}
			}
		}
	}

	.tagsbtn {
		margin: 15px;

		button {
			padding: 10px 15px;
		}

		.van-button-active {
			color: #55aaff;
		}
	}

	.gotocodestyle {
		position: fixed;
		bottom: 30px;
		left: 5%;
		width: 90%;
	}

	.codemain {
		padding-bottom: 80px;
	}
</style>
